/* SSR
const { data } = await useAsyncData(
  `${props.postType}-article-list`, <-- This is the key for the cache
  () =>
    useAlgoliaSearch({
      query: searchQuery.value, <-- This is the search query
      requestOptions: { <-- This is the search options
        hitsPerPage: 1000,
        filters: `category:'${props.postType}'`,
        clickAnalytics: true,
        userToken: gaUserToken.value,
      },
    }),
  {
    watch: [searchQuery], <-- This is the watch array if you want to re-fetch the data
  },
);
*/

/* Client Side
useAlgoliaSearch({
  query: searchQuery.value, <-- This is the search query
  requestOptions: { <-- This is the search options
    hitsPerPage: 1000,
    filters: `category:'${props.postType}'`,
    clickAnalytics: true,
    userToken: gaUserToken.value,
  },
})
*/

import type { SearchParams, SearchResponse } from "@algolia/client-search";
import type { Hit } from "@/types/algolia";

export const useAlgoliaSearch = async (
  searchParams?: { query?: string; requestOptions: SearchParams },
  indexName?: string,
): Promise<SearchResponse<Hit>> => {
  try {
    const config = useRuntimeConfig();
    const route = useRoute();

    return await $fetch<SearchResponse<Hit>>("/api/search/", {
      method: "POST",
      headers: {
        "x-api-token": config.public.algolia.searchToken as string,
      },
      body: {
        searchParams,
        indexName,
        route: route.path, // Pass the current route path for analytics
      },
    });
  } catch (error) {
    throw new Error("[algolia] Error: " + (error as Error).message);
  }
};
